import service from "./index";

// 登录
export const loginFn = (Param, RequestModel) => {
  return service.post("/api/websiteecg", {
    Command: "E00115",
    Param,
    RequestModel,
  });
};

// 用户基本信息
export const getUserInfo = () => {
  return service.post("/api/websiteecg", {
    Command: "E00041",
    Param: { Type: "UserInfo", USER_UID: localStorage.getItem("loginRealId") },
    RequestModel: null,
  });
};

// 医院列表   不需要Token
export const getLoginHospitalList = () => {
  return service.post("/api/websiteecg", {
    Command: "E00041",
    Param: { Type: "Hospital" },
    RequestModel: null,
  });
};

// 预约登记(预约)
export const patientAppointment = (Param, RequestModel) => {
  return service.post("/api/websiteecg", {
    Command: "E00101",
    Param,
    RequestModel,
  });
};

// 预约登记(修改)
export const editExamInfo = (Param, RequestModel) => {
  return service.post("/api/websiteecg", {
    Command: "E00101",
    Param,
    RequestModel,
  });
};

// 预约登记--病人信息(新建保存)
export const addPreservation = (Param, RequestModel) => {
  return service.post("/api/websiteecg", {
    Command: "E00100",
    Param,
    RequestModel,
  });
};

// 预约登记--病人信息(修改保存)
export const editPreservation = (RequestModel) => {
  return service.post("/api/websiteecg", {
    Command: "E00100",
    Param: { Type: "PATIENTEDIT" },
    RequestModel,
  });
};

// 预约登记---右键呼叫患者
export const callPatient = (Param) => {
  return service.post("/api/websiteecg", {
    Command: "E00102",
    Param,
    RequestModel: null,
  });
};

// 预约登记---切换检查房间
export const editExamRoom = (Param) => {
  return service.post("/api/websiteecg", {
    Command: "E00102",
    Param,
    RequestModel: null,
  });
};

// 预约登记---双击一行-编辑 待预约、预约、登记列表
export const editStayAppointmentList = (Param) => {
  return service.post("/api/websiteecg", {
    Command: "E00100",
    Param,
    RequestModel: null,
  });
};

// 预约登记---双击一行-编辑 预约列表
// export const editAppointmentList = (Param) => {
//   return service.post('/api/websiteecg', { Command: 'E00100', Param, RequestModel: null })
// }

// 预约登记---双击一行-编辑 登记列表
// export const editRegisterList = (Param) => {
//   return service.post('/api/websiteecg', { Command: 'E00100', Param, RequestModel: null })
// }

// 预约登记---待预约列表查询
export const stayAppointmentQuery = (Param) => {
  return service.post("/api/websiteecg", {
    Command: "E00100",
    Param,
    RequestModel: null,
  });
};

// 预约登记---预约列表查询
export const appointmentQuery = (Param) => {
  return service.post("/api/websiteecg", {
    Command: "E00102",
    Param,
    RequestModel: null,
  });
};

// 预约登记---登记查询列表
export const registerQuery = (Param) => {
  return service.post("/api/websiteecg", {
    Command: "E00102",
    Param,
    RequestModel: null,
  });
};

// 预约登记---排队列表查询
export const calllQuery = (Param) => {
  return service.post("/api/websiteecg", {
    Command: "E00102",
    Param,
    RequestModel: null,
  });
};

// 预约登记---检查房间列表
export const examRoomList = (Param) => {
  return service.post("/api/websiteecg", {
    Command: "E00102",
    Param,
    RequestModel: null,
  });
};

// 电子叫号---右键切换检查房间
export const getWaitExamData = (Param) => {
  return service.post("/api/websiteecg", {
    Command: "E00103",
    Param,
    RequestModel: null,
  });
};

// 电子叫号---暂停就诊
export const suspensionTreatment = (Param) => {
  return service.post("/api/websiteecg", {
    Command: "E00103",
    Param,
    RequestModel: null,
  });
};

// 电子叫号---呼叫
export const updateCall = (Param) => {
  return service.post("/api/websiteecg", {
    Command: "E00103",
    Param,
    RequestModel: null,
  });
};

// 电子叫号---过号
export const passCallNumber = (Param) => {
  return service.post("/api/websiteecg", {
    Command: "E00103",
    Param,
    RequestModel: null,
  });
};

// 电子叫号---顺呼
export const sequentialCall = (Param) => {
  return service.post("/api/websiteecg", {
    Command: "E00103",
    Param,
    RequestModel: null,
  });
};

// 电子叫号---已到检
export const arrivedCheck = (Param) => {
  return service.post("/api/websiteecg", {
    Command: "E00103",
    Param,
    RequestModel: null,
  });
};

// 电子叫号---检查完成
export const checkComplete = (Param) => {
  return service.post("/api/websiteecg", {
    Command: "E00103",
    Param,
    RequestModel: null,
  });
};

//数据统计申请医院列表会诊医院列表
export const getHospitalList = () => {
  return service.post("/api/websiteecg", {
    Command: "E00106",
    Param: { Type: "HospitalList" },
    RequestModel: null,
  });
};

//数据统计申请医院列表会诊医院列表--加分组的
export const getHospitalListGroups = (Param) => {
  return service.post("/api/websiteecg", {
    Command: "E00106",
    Param,
    RequestModel: null,
  });
};

//数据统计监管机构统计列表
export const getStatisticsList = (Param, RequestModel) => {
  return service.post("/api/websiteecg", {
    Command: "E00113",
    Param,
    RequestModel,
  });
};

//典型病例下拉基础信息   远程会诊下拉基础信息  远程申请下拉基础信息
export const getTypicalCasesBaseInfo = () => {
  return service.post("/api/websiteecg", {
    Command: "E00041",
    Param: { Type: "AllBasicData" },
    RequestModel: null,
  });
};

// 典型病例列表   远程会诊列表、未读消息气泡  远程申请列表
export const getTypicalCasesList = (Param) => {
  return service.post("/api/websiteecg", {
    Command: "E00107",
    Param,
    RequestModel: null,
  });
};

//取消病例收藏   获取患者信息   患者信息    收藏患者病例   申请会诊
export const cancelCollect = (Param, RequestModel) => {
  return service.post("/api/websiteecg", {
    Command: "E00107",
    Param,
    RequestModel,
  });
};
//根据检查ID获取患者详细信息
export const getExamInfo = (EXAM_UID) => {
  return service.post("/api/websiteecg", {
    Command: "E00107",
    Param: { Type: "GetPatientList", EXAM_UID },
    RequestModel: null,
  });
};
//完成会诊
export const completeConsultant = (RequestModel) => {
  return service.post("/api/websiteecg", {
    Command: "E00107",
    Param: { Type: "Completeconsultation" },
    RequestModel,
  });
};
//完成会诊同步数据
export const finishConsultant = (Param) => {
  return service.post("/api/websiteecg", {
    Command: "E00114",
    Param,
    RequestModel: null,
  });
};

//消息提醒
export const msgNotice = (Param, RequestModel) => {
  return service.post("/api/websiteecg", {
    Command: "E00107",
    Param,
    RequestModel,
  });
};

//病例退回
export const returnedCase = (RequestModel) => {
  return service.post("/api/websiteecg", {
    Command: "E00107",
    Param: { Type: "Returned" },
    RequestModel,
  });
};

//删除报告
export const deleteReport = (RequestModel) => {
  return service.post("/api/websiteecg", {
    Command: "E00107",
    Param: { Type: "DELETEReport" },
    RequestModel,
  });
};

//催办
export const urging = (Param, RequestModel) => {
  return service.post("/api/websiteecg", {
    Command: "E00107",
    Param,
    RequestModel,
  });
};

//取消会诊
export const canceAppointment = (RequestModel) => {
  return service.post("/api/websiteecg", {
    Command: "E00107",
    Param: {
      Type: "DELETE",
    },
    RequestModel,
  });
};

// 开始检查更新检查状态
export const checkExam = (RequestModel) => {
  return service.post("/api/websiteecg", {
    Command: "E00086",
    Param: { Type: "EditExam" },
    RequestModel,
  });
};

// 开始报告更新报告状态
export const reportState = (RequestModel) => {
  return service.post("/api/websiteecg", {
    Command: "E00086",
    Param: { Type: "Report" },
    RequestModel,
  });
};

// 开始报告更新审核状态
export const checkReport = (Type, RequestModel) => {
  return service.post("/api/websiteecg", {
    Command: "E00086",
    Param: { Type },
    RequestModel,
  });
};

// 可申请会诊医院列表
export const remoteHospitalList = (Param, RequestModel) => {
  return service.post("/api/websiteecg", {
    Command: "E00153",
    Param,
    RequestModel,
  });
};

// 危急列表
export const getDangerList = () => {
  return service.post("/api/websiteecg", {
    Command: "E00068",
    Param: { Type: "SELECT" },
    RequestModel: null,
  });
};

//新增危急
export const addDanger = (RequestModel) => {
  return service.post("/api/websiteecg", {
    Command: "E00068",
    Param: { Type: "ADD" },
    RequestModel,
  });
};

//编辑危急
export const editDanger = (RequestModel) => {
  return service.post("/api/websiteecg", {
    Command: "E00068",
    Param: { Type: "EDIT" },
    RequestModel,
  });
};

//删除危急
export const deleteDanger = (RequestModel) => {
  return service.post("/api/websiteecg", {
    Command: "E00068",
    Param: { Type: "DELETE" },
    RequestModel,
  });
};

//新建患者
export const newPatient = (Param, RequestModel) => {
  return service.post("/api/websiteecg", {
    Command: "E00051",
    Param,
    RequestModel,
  });
};

//检查科室  检查房间  检查医生
export const deptDoctor = (Param, RequestModel) => {
  return service.post("/api/websiteecg", {
    Command: "E00041",
    Param,
    RequestModel,
  });
};

//原始诊断图像
export const getOriginalImage = (Param, RequestModel) => {
  return service.post("/api/websiteecg", {
    Command: "E00055",
    Param,
    RequestModel,
  });
};

//诊断参数信息更改
export const editDiagnostic = (RequestModel) => {
  return service.post("/api/websiteecg", {
    Command: "E00056",
    Param: null,
    RequestModel,
  });
};

//提交/审核报告结论
export const submitConclusion = (Param) => {
  return service.post("/api/websiteecg", {
    Command: "E00057",
    Param,
    RequestModel: null,
  });
};

//获取报告
export const getReport = () => {
  return service.post("/api/websiteecg", {
    Command: "E00041",
    Param: { Type: "TreeData" },
    RequestModel: null,
  });
};

//打印图片
export const printPic = (EXAM_UID) => {
  return service.get("/api/WebSiteUplodFile?strExamUID=" + EXAM_UID);
};

//提示消息列表    标记为已读
export const messageInfoList = (Param, RequestModel) => {
  return service.post("/api/websiteecg", {
    Command: "E00066",
    Param,
    RequestModel,
  });
};

// 词库树列表
export const getTreeData = (Param) => {
  return service.post("/api/websiteecg", {
    Command: "E00077",
    Param,
    RequestModel: null,
  });
};

// 新增医院词库
export const addTreeData = (Param, RequestModel) => {
  return service.post("/api/websiteecg", {
    Command: "E00077",
    Param,
    RequestModel,
  });
};

// 词库树列表删除
export const DeleteTree = (Param) => {
  return service.post("/api/websiteecg", {
    Command: "E00077",
    Param,
    RequestModel: null,
  });
};

// 医院词库树列表同步
export const SyncTree = (Param) => {
  return service.post("/api/websiteecg", {
    Command: "E00077",
    Param,
    RequestModel: null,
  });
};

// 医院词库赋值
export const TreeAssignment = (Param) => {
  return service.post("/api/websiteecg", {
    Command: "E00077",
    Param,
    RequestModel: null,
  });
};

// 系统设置->房间管理列表
export const getRoomList = (Param) => {
  return service.post("/api/websiteecg", {
    Command: "E00075",
    Param,
    RequestModel: null,
  });
};

// 系统设置->添加房间信息
export const getAddRoomInfo = (Param, RequestModel) => {
  return service.post("/api/websiteecg", {
    Command: "E00075",
    Param,
    RequestModel,
  });
};

// 系统设置->修改房间信息
export const getEditRoomInfo = (RequestModel) => {
  return service.post("/api/websiteecg", {
    Command: "E00075",
    Param: { Type: "ROOM_INFOEDIT" },
    RequestModel,
  });
};

// 系统设置->医院列表删除
export const deleteRoom = (Param) => {
  return service.post("/api/websiteecg", {
    Command: "E00075",
    Param,
    RequestModel: null,
  });
};

// 权限管理、系统设置->所属医院列表
export const getAffiliatedHospitelList = () => {
  return service.post("/api/websiteecg", {
    Command: "E00106",
    Param: {
      Type: "AffiliatedHospitalList",
      USER_UID: JSON.parse(localStorage.getItem("userInfo")).USER_UID || "",
    },
    RequestModel: null,
  });
};

// 系统设置->检查项目管理列表
export const getExamItemList = (Param) => {
  return service.post("/api/websiteecg", {
    Command: "E00074",
    Param,
    RequestModel: null,
  });
};

// 系统设置->检查项目新增
export const getAddExamItem = (Param, RequestModel) => {
  return service.post("/api/websiteecg", {
    Command: "E00074",
    Param,
    RequestModel,
  });
};

// 系统设置->检查项目修改
export const getEditExamItem = (RequestModel) => {
  return service.post("/api/websiteecg", {
    Command: "E00074",
    Param: { Type: "EXAM_ITEMEDIT" },
    RequestModel,
  });
};

// 系统设置->检查项目删除
export const deleteProject = (Param) => {
  return service.post("/api/websiteecg", {
    Command: "E00074",
    Param,
    RequestModel: null,
  });
};

// 系统设置->模板管理列表
export const getTemplateList = (Param) => {
  return service.post("/api/websiteecg", {
    Command: "E00078",
    Param,
    RequestModel: null,
  });
};

// 系统设置->模板管理赋值
export const getTemplatebyuid = (Param) => {
  return service.post("/api/websiteecg", {
    Command: "E00078",
    Param,
    RequestModel: null,
  });
};

// 系统设置->模板管理赋值
export const deleteTemplate = (Param) => {
  return service.post("/api/websiteecg", {
    Command: "E00078",
    Param,
    RequestModel: null,
  });
};

// 系统设置->模板管理同步
export const getSynchronization = (Param) => {
  return service.post("/api/websiteecg", {
    Command: "E00078",
    Param,
    RequestModel: null,
  });
};

// 系统设置->模板管理新增
export const getAddTemplate = (Param, RequestModel) => {
  return service.post("/api/websiteecg", {
    Command: "E00078",
    Param,
    RequestModel,
  });
};

// 系统设置->模板管理编辑
export const getEditTemplate = (Param, RequestModel) => {
  return service.post("/api/websiteecg", {
    Command: "E00078",
    Param,
    RequestModel,
  });
};

//远程会诊 新增患者，编辑患者
export const SubmitInspect = (Param, RequestModel) => {
  return service.post("/api/websiteecg", {
    Command: "E00116",
    Param,
    RequestModel,
  });
};

//权限管理医院列表
export const selectHospitalList = (Param) => {
  return service.post("/api/websiteecg", {
    Command: "E00106",
    Param,
    RequestModel: null,
  });
};

//权限列表
export const roleMenuList = () => {
  return service.post("/api/websiteecg", {
    Command: "E00106",
    Param: { Type: "role_menuList" },
    RequestModel: null,
  });
};

//删除医院
export const deleteHospital = (Param) => {
  return service.post("/api/websiteecg", {
    Command: "E00106",
    Param,
    RequestModel: null,
  });
};

//新增医院
export const addHospital = (Param, RequestModel) => {
  return service.post("/api/websiteecg", {
    Command: "E00106",
    Param,
    RequestModel,
  });
};

//会诊权限
export const Privilege = (Param, RequestModel) => {
  return service.post("/api/websiteecg", {
    Command: "E00106",
    Param,
    RequestModel,
  });
};

//获取选中的会诊医院和申请医院
export const getSelectedHospital = (Param, RequestModel) => {
  return service.post("/api/websiteecg", {
    Command: "E00106",
    Param,
    RequestModel,
  });
};

//权限列表  删除科室  添加科室   编辑科室  获取科室
export const departmentList = (Param, RequestModel) => {
  return service.post("/api/websiteecg", {
    Command: "E00064",
    Param,
    RequestModel,
  });
};

export const deptSelect = (Param, RequestModel) => {
  return service.post("/api/websiteecg", {
    Command: "E00106",
    Param,
    RequestModel,
  });
};

//获取用户角色列表
export const getRoleList = () => {
  return service.post("/api/websiteecg", {
    Command: "E00067",
    Param: { Type: "GetRoleList" },
    RequestModel: null,
  });
};

//医院权限列表
export const hospitalMenuData = (Param) => {
  return service.post("/api/websiteecg", {
    Command: "E00106",
    Param,
    RequestModel: null,
  });
};

//用户列表
export const userSelect = (Param) => {
  return service.post("/api/websiteecg", {
    Command: "E00106",
    Param,
    RequestModel: null,
  });
};

//删除用户
export const deleteUser = (Param) => {
  return service.post("/api/websiteecg", {
    Command: "E00065",
    Param,
    RequestModel: null,
  });
};

//添加用户权限
// export const addReturnAudit = (Param, RequestModel) => {
//   return service.post('/api/websiteecg', { Command: 'E00067', Param, RequestModel })
// }

//添加用户
export const addUser = (Param, RequestModel) => {
  return service.post("/api/websiteecg", {
    Command: "E00106",
    Param,
    RequestModel,
  });
};

//获取用户权限
// export const getReturnAudit = (Param) => {
//   return service.post('/api/websiteecg', { Command: 'E00067', Param, RequestModel: null })
// }

// 角色列表   删除角色   添加角色
export const roleInfoSelect = (Param, RequestModel) => {
  return service.post("/api/websiteecg", {
    Command: "E00106",
    Param,
    RequestModel,
  });
};

//远程申请 新增编辑患者，申请科室
export const initHospitalDepts = (Param) => {
  return service.post("/api/websiteecg", {
    Command: "E00041",
    Param,
    RequestModel: null,
  });
};

//远程申请 新增编辑患者，检查房间
export const initExamRoomList = (Param) => {
  return service.post("/api/websiteecg", {
    Command: "E00041",
    Param,
    RequestModel: null,
  });
};

//远程申请 新增编辑患者 申请医生
export const initDeptDoctor = (Param) => {
  return service.post("/api/websiteecg", {
    Command: "E00041",
    Param,
    RequestModel: null,
  });
};

//移交会诊
export const TransferConsultation = (Param) => {
  return service.post("/api/websiteecg", {
    Command: "E00107",
    Param,
    RequestModel: null,
  });
};

//质控管理
export const QualityControlData = (Param) => {
  return service.post("/api/websiteecg", {
    Command: "E00110",
    Param,
    RequestModel: null,
  });
};

//获取会诊人是否有审核权限
export const GetConsultationPrivilege = (Param) => {
  return service.post("/api/websiteecg", {
    Command: "E00107",
    Param,
    RequestModel: null,
  });
};
//根据会诊医院获取申请医院
export const getConsultationApplyHospital = (HOSPITAL_CODE) => {
  return service.post("/api/websiteecg", {
    Command: "E00117",
    Param: { Type: "GetAllApplyHospital", HOSPITAL_CODE },
    RequestModel: null,
  });
};
//根据会诊医院获取申请医院--加分组的
export const getConsultationApplyHospitalGroup = (Param) => {
  return service.post("/api/websiteecg", {
    Command: "E00117",
    Param,
    RequestModel: null,
  });
};
//根据会诊医院获取会诊人
export const getDoctorList = (hospital_Code) => {
  return service.post("/api/websiteecg", {
    Command: "E00117",
    Param: { Type: "GetDoctorList", hospital_Code },
    RequestModel: null,
  });
};
//根据会诊医院获取会诊人
export const getCustomData = (Param) => {
  return service.post("/api/websiteecg", {
    Command: "E00117",
    Param,
    RequestModel: null,
  });
};
//根据申请医院获取申请科室
export const getHospitalDept = (hospital_Code) => {
  return service.post("/api/websiteecg", {
    Command: "E00041",
    Param: { Type: "Hospital_Dept", hospital_Code },
    RequestModel: null,
  });
};
//会诊量统计表(不包含申请医院)
export const getConsultationTotal = (data) => {
  return service.post("/api/websiteecg", {
    Command: "E00117",
    Param: { Type: "ConsultationTotalVariable", ...data },
    RequestModel: null,
  });
};
//会诊量统计表(选择申请医院的)
export const getApplyHospitalConsultation = (data) => {
  return service.post("/api/websiteecg", {
    Command: "E00117",
    Param: { Type: "ApplyHospital_ConsultationVariable", ...data },
    RequestModel: null,
  });
};
//医生工作量统计
export const getDoctorWorkload = (data) => {
  return service.post("/api/websiteecg", {
    Command: "E00117",
    Param: { Type: "DoctorWorkload", ...data },
    RequestModel: null,
  });
};
//医生开单量统计
export const getBillDoctorWorkload = (data) => {
  return service.post("/api/websiteecg", {
    Command: "E00117",
    Param: { Type: "Billing_DoctorWorkload", ...data },
    RequestModel: null,
  });
};
//开单统计--医院列表
export const getBillingHospitalList = (Param) => {
  return service.post("/api/websiteecg", {
    Command: "E00117",
    Param: { ...Param },
    RequestModel: null,
  });
};
//开单统计--医生列表
export const getBillingDoctorList = (Param) => {
  return service.post("/api/websiteecg", {
    Command: "E00117",
    Param,
    RequestModel: null,
  });
};
//会诊量统计（折线图）
export const getYearConsultation = (data) => {
  return service.post("/api/websiteecg", {
    Command: "E00117",
    Param: { Type: "YearConsultation", ...data },
    RequestModel: null,
  });
};
//会诊量统计（柱状图）
export const getConsultationVolumeAll = (data) => {
  return service.post("/api/websiteecg", {
    Command: "E00117",
    Param: { Type: "ConsultationVolumeAll", ...data },
    RequestModel: null,
  });
};
//医生工作量导出
export const getExportDoctorWorkload = (data) => {
  return service.post("/api/websiteecg", {
    Command: "E00117",
    Param: { Type: "ExportDoctorWorkload", ...data },
    RequestModel: null,
  });
};
//会诊量统计导出
export const getExportConsultationVolume = (data) => {
  return service.post("/api/websiteecg", {
    Command: "E00117",
    Param: { Type: "ExportConsultationVolume", ...data },
    RequestModel: null,
  });
};
//开单量统计导出
export const getExportBillDoctorWorkload = (data) => {
  return service.post("/api/websiteecg", {
    Command: "E00117",
    Param: { Type: "ExportBilling_DoctorWorkload", ...data },
    RequestModel: null,
  });
};
//自定义查询导出
export const getExportCustomData = (Param) => {
  return service.post("/api/websiteecg", {
    Command: "E00117",
    Param,
    RequestModel: null,
  });
};
//修改密码
export const editPassword = (Param) => {
  return service.post("/api/websiteecg", {
    Command: "E00069",
    Param,
    RequestModel: null,
  });
};
//质量控制查询
export const getQualityControl = (Param) => {
  return service.post("/api/websiteecg", {
    Command: "E00110",
    Param,
    RequestModel: null,
  });
};
//质量控制合格不合格
export const qualified = (RequestModel) => {
  return service.post("/api/websiteecg", {
    Command: "E00110",
    Param: { Type: "UpdateQuality" },
    RequestModel,
  });
};

//质量控制双击打开报告
export const getExamImageApp = (Param) => {
  return service.post("/api/websiteecg", {
    Command: "E00114",
    Param,
    RequestModel: null,
  });
};

export const getCheckedTypeList = () => {
  return service.post("/api/websiteecg", {
    Command: "E00119",
    Param: { Type: "SELECT", pageNo: 1, pageSize: 10, NAME: "" },
    RequestModel: null,
  });
};
//添加检查类型
export const addCheckType = (HOSPITAL_CODE, data) => {
  return service.post("/api/websiteecg", {
    Command: "E00119",
    Param: { Type: "Add", HOSPITAL_CODE },
    RequestModel: { DELETE_FLAG: 0, ...data },
  });
};
//修改检查类型
export const editCheckType = (data) => {
  return service.post("/api/websiteecg", {
    Command: "E00119",
    Param: { Type: "Edit" },
    RequestModel: { DELETE_FLAG: 0, ...data },
  });
};
//删除检查类型
export const deleteCheckType = (RequestModel) => {
  return service.post("/api/websiteecg", {
    Command: "E00119",
    Param: { Type: "Delete" },
    RequestModel,
  });
};

//检查子类列表
export const getCheckChildTypeList = (data) => {
  return service.post("/api/websiteecg", {
    Command: "E00120",
    Param: { Type: "SELECT", ...data },
    RequestModel: null,
  });
};
//添加检查子类
export const addCheckChildType = (HOSPITAL_CODE, data) => {
  return service.post("/api/websiteecg", {
    Command: "E00120",
    Param: { Type: "Add", HOSPITAL_CODE },
    RequestModel: { DELETE_FLAG: 0, ...data },
  });
};
//修改检查子类
export const editCheckChildType = (data) => {
  return service.post("/api/websiteecg", {
    Command: "E00120",
    Param: { Type: "EditHK" },
    RequestModel: { DELETE_FLAG: 0, ...data },
  });
};
//删除检查子类
export const deleteCheckChildType = (RequestModel) => {
  return service.post("/api/websiteecg", {
    Command: "E00120",
    Param: { Type: "DeleteHK" },
    RequestModel,
  });
};

//检查项目列表
// export const getCheckProjectList = (data) => {
// 	return service.post("/api/websiteecg", {
// 		Command: "E00074",
// 		Param: { Type: "SELECT", ...data },
// 		RequestModel: null,
// 	});
// };

//检查项目列表
export const getCheckProjectList = (data) => {
  return service.post("/api/websiteecg", {
    Command: "E00074",
    Param: { Type: "SELECT_VIEW", ...data },
    RequestModel: null,
  });
};
//添加检查项目
export const addCheckProject = (HOSPITAL_CODE, data) => {
  return service.post("/api/websiteecg", {
    Command: "E00074",
    Param: { Type: "Add", HOSPITAL_CODE },
    RequestModel: { DELETE_FLAG: 0, ...data },
  });
};
//修改检查项目
export const editCheckProject = (data) => {
  return service.post("/api/websiteecg", {
    Command: "E00074",
    Param: { Type: "EditHK" },
    RequestModel: { DELETE_FLAG: 0, ...data },
  });
};
//删除检查项目
export const deleteCheckProject = (RequestModel) => {
  return service.post("/api/websiteecg", {
    Command: "E00074",
    Param: { Type: "DeleteHK" },
    RequestModel,
  });
};

//新建患者检查类型、子类、项目级联菜单
export const getExamItem = (HOSPITAL_UID) => {
  return service.post("/api/websiteecg", {
    Command: "E00041",
    Param: { Type: "HospitalExamItem", HOSPITAL_UID },
    RequestModel: null,
  });
};

//患者来源列表
export const getPatientSourceList = (data) => {
  return service.post("/api/websiteecg", {
    Command: "E00121",
    Param: { Type: "SELECT", ...data },
    RequestModel: null,
  });
};
//添加患者来源
export const addPatientSource = (HOSPITAL_CODE, data) => {
  return service.post("/api/websiteecg", {
    Command: "E00121",
    Param: { Type: "Add", HOSPITAL_CODE },
    RequestModel: { DELETE_FLAG: 0, ...data },
  });
};
//编辑患者来源
export const editPatientSource = (data) => {
  return service.post("/api/websiteecg", {
    Command: "E00121",
    Param: { Type: "Edit" },
    RequestModel: { DELETE_FLAG: 0, ...data },
  });
};
//删除患者来源
export const deletePatientSource = (RequestModel) => {
  return service.post("/api/websiteecg", {
    Command: "E00121",
    Param: { Type: "Delete" },
    RequestModel,
  });
};

//获取静息心电诊断分析参数
export const getEcgValue = (exam_uid) => {
  return service.post("/api/websiteecg", {
    Command: "E00041",
    Param: { Type: "ecg_value", exam_uid },
    RequestModel: null,
  });
};

//修改静息心电诊断分析参数
export const setEcgValue = (RequestModel) => {
  return service.post("/api/websiteecg", {
    Command: "E00056",
    Param: null,
    RequestModel,
  });
};

//开始报告/审核
export const startReport = (Param) => {
  return service.post("/api/websiteecg", {
    Command: "E00057",
    Param,
    RequestModel: null,
  });
};
//获取医生电子签名
export const GetSignatureFile = (EXAM_UID) => {
  return service.post("/api/websiteecg", {
    Command: "E00130",
    Param: { Type: "GetSignatureFile", EXAM_UID },
    RequestModel: null,
  });
};

//根据病例ID获取该病例的会诊信息
export const getRemoteInfo = (EXAM_UID) => {
  return service.post("/api/websiteecg", {
    Command: "E00041",
    Param: { Type: "RemoteInfo", EXAM_UID },
    RequestModel: null,
  });
};

//获取其他配置项列表（分页）
export const getOtherSettingList = (Param) => {
  return service.post("/api/websiteecg", {
    Command: "E00130",
    Param,
    RequestModel: null,
  });
};
//获取其他配置项列表(不分页)
export const getOtherSettingListNo = (SET_TYPE) => {
  return service.post("/api/websiteecg", {
    Command: "E00130",
    Param: { Type: "GetData", SET_TYPE },
    RequestModel: null,
  });
};

//其他配置项新建转诊编辑
export const getOtherSettingReferralInfo = (RequestModel) => {
  return service.post("/api/websiteecg", {
    Command: "E00130",
    Param: { Type: "GetData", SET_TYPE: 2 },
    RequestModel: null,
  });
};

//其他配置项编辑
export const getOtherSettingEdit = (RequestModel) => {
  return service.post("/api/websiteecg", {
    Command: "E00130",
    Param: { Type: "UPDATE" },
    RequestModel,
  });
};

//远程申请、会诊添加患者症状和检查信息
export const getEditPatientExamInfo = (Param) => {
  return service.post("/api/websiteecg", {
    Command: "E00107",
    Param,
    RequestModel: null,
  });
};

/*--------------------------------------------------单项转诊相关---------------------------------------------------------------------*/

//单项转诊-新建转诊
export const getNewReferral = (Param, RequestModel) => {
  return service.post("/api/websiteecg", {
    Command: "E00139",
    Param,
    RequestModel,
  });
};

//单项转诊-转诊列表-申请端
export const getReferralData = (Param) => {
  return service.post("/api/websiteecg", {
    Command: "E00139",
    Param,
    RequestModel: null,
  });
};

//单项转诊-申请转诊
export const getApplyReferredData = (RequestModel) => {
  return service.post("/api/websiteecg", {
    Command: "E00139",
    Param: { Type: "ApplyReferred" },
    RequestModel,
  });
};

//单项转诊-取消转诊
export const getCancelReferral = (Param) => {
  return service.post("/api/websiteecg", {
    Command: "E00139",
    Param,
    RequestModel: null,
  });
};

//单项转诊-删除转诊
export const getDeleteReferred = (Param) => {
  return service.post("/api/websiteecg", {
    Command: "E00139",
    Param,
    RequestModel: null,
  });
};

//接收转诊列表
export const getReferredData = (Param) => {
  return service.post("/api/websiteecg", {
    Command: "E00139",
    Param,
    RequestModel: null,
  });
};
//接收转诊功能
export const ReceiveReferral = (Param) => {
  return service.post("/api/websiteecg", {
    Command: "E00139",
    Param,
    RequestModel: null,
  });
};
//接收完成出院
export const CompleteDischarged = (Param) => {
  return service.post("/api/websiteecg", {
    Command: "E00139",
    Param,
    RequestModel: null,
  });
};
//接收转诊退回转诊
export const ApplyReferred = (RequestModel) => {
  return service.post("/api/websiteecg", {
    Command: "E00139",
    Param: { Type: "ReturnReferral" },
    RequestModel,
  });
};
//获取申请端医院列表
export const GetApplyHospital = (Param) => {
  return service.post("/api/websiteecg", {
    Command: "E00139",
    Param,
    RequestModel: null,
  });
};

//根据病历号获取病人基本信息（his）
export const getPatientInfo = (EXAM_NO, HOSPITAL_CODE) => {
  return service.post("api/websiteecg", {
    Command: "E00084",
    Param: { Type: "GetPatientInfo", EXAM_NO, HOSPITAL_CODE },
    RequestModel: null,
  });
};
//静息心电图机选择光电12导(服务器)-xml
export const getCheckId = (Param) => {
  return service.post("api/websiteecg", {
    Command: "E00138",
    Param,
    RequestModel: null,
  });
};

//转诊发送消息
export const referralMsgNotice = (HOSPITAL_CODE, RequestModel) => {
  return service.post("/api/websiteecg", {
    Command: "E00139",
    Param: { Type: "MsgNotice", HOSPITAL_CODE },
    RequestModel,
  });
};

//根据分组模糊搜索获取所有会诊医院
export const getHospitalListGroup = (Type, DATA_GROUP) => {
  return service.post("/api/websiteecg", {
    Command: "E00106",
    Param: { Type, DATA_GROUP },
    RequestModel: null,
  });
};

//根据分组获取会诊权限
export const getIsPrivilege = (Param) => {
  return service.post("/api/websiteecg", {
    Command: "E00106",
    Param,
    RequestModel: null,
  });
};

//获取待完善列表
export const getWaitImprovedList = (Param) => {
  return service.post("/api/websiteecg", {
    Command: "E00138",
    Param,
    RequestModel: null,
  });
};

//待完善列表--根据EXAM_UID获取患者基本信息
// export const getPatientInfos = (EXAM_UID) => {
//   return service.post('/api/websiteecg', { Command: 'E00041', Param: { Type: 'PatientInfo', EXAM_UID }, RequestModel: null })
// }

//待完善列表--根据EXAM_UID删除患者信息
export const deleteWaitImproved = (UID_LIST) => {
  return service.post("/api/websiteecg", {
    Command: "E00138",
    Param: { Type: "DELETE", UID_LIST },
    RequestModel: null,
  });
};

//申请列表导出
export const applyExportList = (params) => {
  return service.post("/api/websiteecg", {
    Command: "E00107",
    Param: { Type: "ExportData", ...params },
    RequestModel: null,
  });
};

//撤回申请
export const revokeApply = (Param) => {
  return service.post("/api/websiteecg", {
    Command: "E00107",
    Param,
    RequestModel: null,
  });
};

//本地工作量查询
export const getOrganizationWorkList = (params) => {
  return service.post("/api/websiteecg", {
    Command: "E00113",
    Param: { Type: "LocalWorkload", ...params },
    RequestModel: null,
  });
};

//本地工作量导出
export const exportOrganizationWorkList = (params) => {
  return service.post("/api/websiteecg", {
    Command: "E00113",
    Param: { Type: "ExportLocalWorkload", ...params },
    RequestModel: null,
  });
};

//本地工作量查询
export const getDoctorWorkList = (params) => {
  return service.post("/api/websiteecg", {
    Command: "E00113",
    Param: { Type: "LocalDoctorWorkload", ...params },
    RequestModel: null,
  });
};

//本地工作量导出
export const exportDoctorWorkList = (params) => {
  return service.post("/api/websiteecg", {
    Command: "E00113",
    Param: { Type: "ExportLocalDoctorWorkload", ...params },
    RequestModel: null,
  });
};

//根据医院获取所有医生列表(不区分申请会诊)
export const getAllDoctorList = (HOSPITAL_CODE) => {
  return service.post("/api/websiteecg", {
    Command: "E00113",
    Param: { Type: "LocalDoctorData", HOSPITAL_CODE },
    RequestModel: null,
  });
};

//获取常规血压列表
export const getTranquillizationBloodList = (param) => {
  return service.post("/api/websiteecg", {
    Command: "E00107",
    Param: { Type: "BPData", EXAM_CLASS: "BP", ...param },
    RequestModel: null,
  });
};

//导出常规血压列表
export const exportTranquillizationBloodList = (param) => {
  return service.post("/api/websiteecg", {
    Command: "E00107",
    Param: { Type: "ExportBPData", EXAM_CLASS: "BP", ...param },
    RequestModel: null,
  });
};
// 本地查询操作医生列表
export const getOperationDoctorList = (Param) => {
  return service.post("/api/websiteecg", {
    Command: "E00117",
    Param,
    RequestModel: null,
  });
};
// 套餐检查量统计表头
export const GetTableHeaderData = (Command, Param) => {
  return service.post("/api/websiteecg", {
    // Command: "E00117",
    Command,
    Param,
    RequestModel: null,
  });
};
// 套餐检查量统计表头
export const GetExportPackageData = (Command, Param) => {
  return service.post("/api/websiteecg", {
    Command,
    Param,
    RequestModel: null,
  });
};

//获取当前登录医生会诊状态(循序判图模式使用)
export const getUserConsultationRecord = (param) => {
  return service.post("/api/websiteecg", {
    Command: "E00041",
    Param: { Type: "GetUserConsultationRecord", userUID: param },
    RequestModel: null,
  });
};

// 获取分组列表
export const getGroupsData = ({ PageSize, PageNo, GROUP_NAME }) => {
  return service.post("/api/websiteecg", {
    Command: "E00141",
    Param: { Type: "GetGroupData", PageSize, PageNo, GROUP_NAME },
    RequestModel: null,
  });
};

// 获取分组列表不分页
export const getGroupsDataNoPaging = () => {
  return service.post("/api/websiteecg", {
    Command: "E00141",
    Param: { Type: "GetGroupDataInfo" },
    RequestModel: null,
  });
};

// 获取一级组别列表
export const getFirstGroupList = () => {
  return service.post("/api/websiteecg", {
    Command: "E00141",
    Param: { Type: "FirstData" },
    RequestModel: null,
  });
};
//获取二级组别列表
export const getSecondGroupList = (FIRST_GROUP_CODE) => {
  return service.post("/api/websiteecg", {
    Command: "E00141",
    Param: { Type: "GetSecondData", FIRST_GROUP_CODE },
    RequestModel: null,
  });
};
// 添加一级组别
export const addFirstGroup = (FIRST_GROUP_NAME, REMARKS) => {
  return service.post("/api/websiteecg", {
    Command: "E00141",
    Param: { Type: "AddFirst" },
    RequestModel: { FIRST_GROUP_NAME, REMARKS },
  });
};
// 添加二级组别
export const addSecondGroup = ({ FIRST_GROUP_CODE, FIRST_GROUP_NAME, SECOND_GROUP_NAME, REMARKS }) => {
  return service.post("/api/websiteecg", {
    Command: "E00141",
    Param: { Type: "AddSecond" },
    RequestModel: {
      FIRST_GROUP_CODE,
      FIRST_GROUP_NAME,
      SECOND_GROUP_NAME,
      REMARKS,
    },
  });
};

// 编辑组别名称
export const editGroup = (RequestModel) => {
  return service.post("/api/websiteecg", {
    Command: "E00141",
    Param: { Type: "Edit" },
    RequestModel,
  });
};

//分组的停用启用
export const updateGroupStatus = ({ GROUP_UID, FIRST_GROUP_CODE, SECOND_GROUP_CODE, IS_ENABLED }) => {
  return service.post("/api/websiteecg", {
    Command: "E00141",
    Param: { Type: "UpdateGroupStatus", GROUP_UID, FIRST_GROUP_CODE, SECOND_GROUP_CODE, IS_ENABLED },
    RequestModel: null,
  });
};
//根据分组获取所有会诊医院列表
export const getConsultationHospitalList = (FIRST_GROUP_CODE, SECOND_GROUP_CODE) => {
  return service.post("/api/websiteecg", {
    Command: "E00106",
    Param: {
      Type: "ConsultationHospitalGroup",
      FIRST_GROUP_CODE, //一级分组
      SECOND_GROUP_CODE, //二级分组
    },
    RequestModel: null,
  });
};

//综合查询模块获取一级分组列表
export const getSearchPartFirstData = (Command, HOSPITAL_CODE) => {
  return service.post("/api/websiteecg", {
    // Command: "E00117",
    Command,
    Param: { Type: "GetFirstData", HOSPITAL_CODE },
    RequestModel: null,
  });
};
//数据统计获取会诊医院列表
export const getConsultationList = (APPLY_HOSPITAL_CODE, FIRST_GROUP_CODE, SECOND_GROUP_CODE) => {
  return service.post("/api/websiteecg", {
    Command: "E00113",
    Param: { Type: "GetConsultationList", APPLY_HOSPITAL_CODE, FIRST_GROUP_CODE, SECOND_GROUP_CODE },
    RequestModel: null,
  });
};
//综合查询模块根据分组、会诊医院、申请医院获取检查项目
export const getGroupExamItemList = (Param) => {
  return service.post("/api/websiteecg", {
    Command: "E00117",
    Param,
    RequestModel: null,
  });
};
//综合查询模块根据分组、会诊医院、申请医院、获取检查子类
export const getGroupExamSubList = (Param) => {
  return service.post("/api/websiteecg", {
    Command: "E00117",
    Param,
    RequestModel: null,
  });
};
//综合查询模块根据分组、会诊医院、申请医院获取申请科室列表
export const getGroupHospitalDept = (Param) => {
  return service.post("/api/websiteecg", {
    Command: "E00117",
    Param,
    RequestModel: null,
  });
};
//综合查询模块根据分组、会诊医院获取会诊人
export const getSearchDoctorList = (Param) => {
  return service.post("/api/websiteecg", {
    Command: "E00117",
    Param,
    RequestModel: null,
  });
};
//综合查询模块获取二级分组列表
export const getSearchPartSecondData = (Command, HOSPITAL_CODE, FIRST_GROUP_CODE) => {
  return service.post("/api/websiteecg", {
    // Command: "E00117",
    Command,
    Param: { Type: "GetSecondData", HOSPITAL_CODE, FIRST_GROUP_CODE },
    RequestModel: null,
  });
};
//添加运营账号
export const addOrEditOperate = (Type, RequestModel) => {
  return service.post("/api/websiteecg", {
    Command: "E00142",
    Param: { Type },
    RequestModel,
  });
};
//删除运营账号
export const deleteOperate = (OPERATION_UID) => {
  return service.post("/api/websiteecg", {
    Command: "E00142",
    Param: {
      Type: "Delete",
      OPERATION_UID,
    },
    RequestModel: null,
  });
};
//查询运营人员列表
export const selectOperate = (Param) => {
  return service.post("/api/websiteecg", {
    Command: "E00142",
    Param,
    RequestModel: null,
  });
};
//获取短信验证码
export const getVerificationCode = (Param) => {
  return service.post("/api/websiteecg", {
    Command: "E00141",
    Param,
    RequestModel: null,
  });
};
//新增编辑管理员时获取分组和医院的树形数据
export const GetAllCheckHospitalInfo = () => {
  return service.post("/api/websiteecg", {
    Command: "E00142",
    Param: {
      Type: "GetAllCheckHospitalInfo",
    },
    RequestModel: null,
  });
};
//新增业务员时获取分组和医院的树形数据
export const GetCheckHospitalInfo = () => {
  return service.post("/api/websiteecg", {
    Command: "E00142",
    Param: {
      Type: "GetCheckHospitalInfo",
    },
    RequestModel: null,
  });
};
//编辑业务员时获取分组和医院的树形数据
export const GetCheckedHospitalInfo = (OPERATION_UID) => {
  return service.post("/api/websiteecg", {
    Command: "E00142",
    Param: {
      Type: "GetCheckedHospitalInfo",
      OPERATION_UID,
    },
    RequestModel: null,
  });
};

//运营账号登录接口
export const operaterLogin = (Param) => {
  return service.post("/api/websiteecg", {
    Command: "E00143",
    Param,
  });
};
//运营账号修改密码
export const operaterChangePassWord = (Param) => {
  return service.post("/api/websiteecg", {
    Command: "E00142",
    Param,
    RequestModel: null,
  });
};
//运营账号修改手机号
export const operaterChangePhoneNum = (Param) => {
  return service.post("/api/websiteecg", {
    Command: "E00142",
    Param,
    RequestModel: null,
  });
};

//日志接口
export const GetLogData = (Param) => {
  return service.post("/api/websiteecg", {
    Command: "E00145",
    Param,
    RequestModel: null,
  });
};
//获取操作员名称

export const GetUserList = (HOSPITAL_CODE) => {
  return service.post("/api/websiteecg", {
    Command: "E00145",
    Param: {
      Type: "GetUserList",
      HOSPITAL_CODE,
    },
    RequestModel: null,
  });
};
//获取自定义签名列表
export const getCustomSignatureList = (params) => {
  return service.post("/api/websiteecg", {
    Command: "E00146",
    Param: {
      Type: "SELECT",
      ...params,
    },
    RequestModel: null,
  });
};
//获取未配置医院列表
export const getNotConfigHospitalList = () => {
  return service.post("/api/websiteecg", {
    Command: "E00146",
    Param: {
      Type: "GetNotConfigHospitalList",
    },
    RequestModel: null,
  });
};
//添加自定义签名
export const addCustomSignature = (params) => {
  return service.post("/api/websiteecg", {
    Command: "E00146",
    Param: {
      Type: "Add",
    },
    RequestModel: params,
  });
};
//修改自定义签名
export const editCustomSignature = (params) => {
  return service.post("/api/websiteecg", {
    Command: "E00146",
    Param: {
      Type: "Edite",
    },
    RequestModel: params,
  });
};
//删除自定义签名
export const delCustomSignature = (ID) => {
  return service.post("/api/websiteecg", {
    Command: "E00146",
    Param: {
      Type: "Delete",
      ID,
    },
    RequestModel: null,
  });
};

//医院管理的项目列表
export const getHospitalItem = () => {
  return service.post("/api/websiteecg", {
    Command: "E00106",
    Param: {
      Type: "SELECT_ITEM",
    },
    RequestModel: null,
  });
};
// 添加/取消危急值病例
export const addCriticalCase = (Param) => {
  return service.post("/api/websiteecg", {
    Command: "E00086",
    Param:{
      Type:"SetDangerValue",
      ...Param
    },
    RequestModel: null,
  });
}
export const cancelCriticalCase = (id) => {
  return service.post("/api/websiteecg", {
    Command: "E00086",
    Param: {
      Type: "CancelDangerValue",
      EXAM_UID: id
    },
    RequestModel: null,
  });
}
export const saveAIResult= (Param) => {
  return service.post("/api/websiteecg", {
    Command: "E00107",
    Param,
    RequestModel: null,
  });
}
// 省份列表（下拉数据）
export const getProvinceData = () => {
	return service.post("/api/websiteecg", {
		Command: "E00153",
		Param: {
			Type: "GetProvince"
		},
		RequestModel: null
	})
}